@if (currentRoute) {
  <div class="wide__page__container">
    <router-outlet></router-outlet>
  </div>
} @else {
  <app-blank-page
    class="centered__page__container"
    headline="No Insight Selected"
    text="Select an insight report from the list on the left to retrieve information about your operations."
  >
  </app-blank-page>
}
